<template>
  <div>
    <el-dialog
      title="生成报告"
      :visible.sync="dialogVisible"
      width="80%"
      append-to-body
      top="5vh"
    >
      <div class="info">
        <ProjectTextReport
          ref="ProjectTextReport"
          :pId="pId"
          :taskId="taskId"
          :isShowLeft="isShowLeft"
          v-if="dialogVisible && pId"
          @successSub="successSub"
        ></ProjectTextReport>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectTextReport from './ProjectTextReport'
export default {
  data() {
    return {
      dialogVisible: false,
      pId: '',
      taskId: '',
      isShowLeft: false,
      ProjectInfoLoading: false,
      ProjectInfo: {},
      printobj: {
        id: 'print-info',
      },
      CumInfo: {},
      a2TableData: [
        {
          role: '移交方代表',
        },
        {
          role: '接收方代表',
        },
        {
          role: '监理方代表',
        },
        {
          role: '业主方代表',
        },
      ],
    }
  },
  props: {},
  components: { ProjectTextReport },
  methods: {
    openDialog(pId, taskId) {
      this.pId = pId
      this.taskId = taskId
      this.dialogVisible = true
    },
    successSub() {
      this.$emit('successSub')
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.info {
  margin: 0 auto;
  height: 75vh;
  overflow-y: auto;
  color: #000000;
  font-size: 14px;
}
</style>
